import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { languagesDataSource } from 'infrastructure/data-sources/languages';
import { sortArrayByFieldName } from 'utils/helpers/sort-array-by-field-name';

import type { ILanguageItem } from 'infrastructure/data-sources/languages';
import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';

interface ILanguageSelectBoxProps extends Omit<IBaseSelectBoxProps, 'options'> {
  englishSpanishOnly?: boolean;
  withAll?: boolean;
}

const LanguageSelectBox: React.FC<ILanguageSelectBoxProps> = (props) => {
  const { englishSpanishOnly, withAll, ...otherProps } = props;
  const languages = useMemo(
    () => languagesDataSource(englishSpanishOnly, withAll),
    [englishSpanishOnly, withAll],
  );

  const options: IBaseSelectBoxOption<ILanguageItem['id'], ILanguageItem>[] =
    useMemo(
      () =>
        languages.map((language) => ({
          value: language.id,
          label: language.name,
          record: language,
        })),
      [languages],
    );

  return (
    <BaseSelectBox
      options={sortArrayByFieldName(options, 'label')}
      {...otherProps}
    />
  );
};

export default LanguageSelectBox;
